import { render, staticRenderFns } from "./JciEventForMembersCreate.vue?vue&type=template&id=ca0cc4aa"
import script from "./JciEventForMembersCreate.vue?vue&type=script&lang=js"
export * from "./JciEventForMembersCreate.vue?vue&type=script&lang=js"
import style0 from "./JciEventForMembersCreate.vue?vue&type=style&index=0&id=ca0cc4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports